import { useEffect, useRef } from 'react'

export function useGlobalPasteListener(
  onPaste: (event: ClipboardEvent) => void,
) {
  const onPasteRef = useRef(onPaste)
  onPasteRef.current = onPaste

  useEffect(() => {
    const handler = (event: ClipboardEvent) => onPasteRef?.current(event)
    document.addEventListener('paste', handler)
    return () => {
      document.removeEventListener('paste', handler)
    }
  }, [onPasteRef])
}
